// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import { ListItemFactory } from "@app/shared";
import { CategoryModel, MenuModel, ProgramPropertyDto, ProjectModel } from "@app/catalog";

export class ProgramPropertyModel 
{
    public id: string = "";    
    public name: WritableSignal<string>;
    public thumbnailUrl: WritableSignal<string>;
    public categories: WritableSignal<CategoryModel[]>;
    public projects: WritableSignal<ProjectModel[]>;
    public hasImageError: WritableSignal<boolean>;
    public menus: WritableSignal<MenuModel>;

    constructor()
    {
        this.name = signal<string>(null);
        this.thumbnailUrl = signal<string>(null);
        this.categories = signal<CategoryModel[]>([]);
        this.projects = signal<ProjectModel[]>([]);
        this.hasImageError = signal<boolean>(false);
        this.menus = signal<MenuModel>(null);
    }

    public handleImageError() {
        this.hasImageError.set(true);
    }


    public static fromDto(dto: ProgramPropertyDto)
    {
        let program = new ProgramPropertyModel();

        program.id = dto.id;
        program.name.set(dto.name);
        program.thumbnailUrl.set(dto.thumbnailUrl);
        program.projects.set(dto.projects?.map(proj=>ProjectModel.fromDto(proj)));
        //TODO:DIW:At somepoint the selected categories could be passed in so CategoryModel.fromDto can have isChecked set properly.
        program.categories.set(dto.categories.map(cat=>CategoryModel.fromDto(cat, false)));    
        program.menus.set(MenuModel.fromDto(dto.menus));    
        return program;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<ProgramPropertyModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<ProgramPropertyModel>(this.name, this.id, this, selected);

}
